export default __webpack_public_path__ + "static/media/catalog_2023FW.94aa702a.jpg";